import { getSrcs, imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import ClearButton from '@stories/Components/ClearButton/ClearButton';
import * as React from 'react';
import S from './IconList.styles';
export var SpanAmount;
(function (SpanAmount) {
    SpanAmount["Default"] = "1";
    SpanAmount["Double"] = "2";
})(SpanAmount || (SpanAmount = {}));
/* Type check to determine if items is an IconItemModel array or an image */
const isIconItemArr = (items) => Array.isArray(items);
const IconList = ({ activeFilter, allowFiltering, items, onClick, onReset, span = SpanAmount.Default, title, }) => {
    const srcs = !isIconItemArr(items) ? getSrcs(items, 892, 235, 6) : [];
    return (React.createElement(S.Container, { "data-to-span": span, "data-show-mobile": !isIconItemArr(items) },
        React.createElement(S.DetailWrapper, null,
            React.createElement(S.TitleWrapper, null,
                React.createElement(S.Title, null, title),
                isIconItemArr(items) ? (React.createElement(ClearButton, { label: "Remove", onClick: () => onReset(), "data-visible": !!allowFiltering && !!items.find((item) => item.value === activeFilter) })) : null),
            React.createElement(S.Options, null, isIconItemArr(items) ? (React.createElement(React.Fragment, null, items.map((item) => (React.createElement("li", { key: `icon-list-${item.id}` },
                React.createElement(S.Option, { ...(item.enabled && allowFiltering && item.value
                        ? {
                            onClick: () => onClick(item.value ?? ''),
                            'data-active': activeFilter === item.value,
                        }
                        : { disabled: true }) },
                    React.createElement(S.Image, { src: imageUrl(item.icon, { width: 57 }), alt: item.label }),
                    React.createElement("span", null, item.value))))))) : (React.createElement(S.ListReplacementImage, { sizes: `${until(Device.TabletSmall)} 100vw, ${until(Device.Desktop)} 50vw, ${until(Device.DesktopLarge)} 75vw, 892px`, src: srcs[0].split(' ')[0], srcSet: srcs.join(','), alt: items.altText ?? title }))))));
};
export default IconList;
